import { render, staticRenderFns } from "./EnergyLegend.vue?vue&type=template&id=a150ae76&scoped=true"
import script from "./EnergyLegend.vue?vue&type=script&lang=ts"
export * from "./EnergyLegend.vue?vue&type=script&lang=ts"
import style0 from "./EnergyLegend.vue?vue&type=style&index=0&id=a150ae76&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a150ae76",
  null
  
)

export default component.exports